const wildcardToRegex = (pattern) => {
  // eslint-disable-next-line no-useless-escape
  const escaped = pattern.replace(/[-\/\\^$+?.()|[\]{}]/g, '\\$&');
  return new RegExp("^" + escaped.replace(/\*/g, ".*") + "$", "i");
}

const checkCondition = (item, condition) => {
  const propRegex = wildcardToRegex(condition.Property);
  const valueRegex = wildcardToRegex(condition.Value);
  return Object.entries(item).some(([key, value]) => {
    if (value !== null && typeof value === "object") return false;
    return propRegex.test(key) && valueRegex.test(String(value));
  });
}

const checkConditions = (item, operation, conditions) => {
  if (operation === 'Or') {
    return conditions.some(condition => checkCondition(item, condition));
  } else if (operation === 'And') {
    return conditions.every(condition => checkCondition(item, condition));
  }
  return true;
}

const applyNavigationFilter = (data, filter) => {
  return data.filter(item => {
    return checkConditions(item, filter.Operation, filter.Conditions);
  })
}

const getElementWithViewTemplateColorAndTag = (template, element) => {
  if (!template || !element) return null;
  let color = "#aaaaaa";
  let tag = null;
  if (template.Colors && template.Colors.Operation && template.Colors.Conditions && template.Colors.Conditions.length > 0) {
    const isValid = checkConditions(element, template.Colors.Operation, template.Colors.Conditions);
    if (isValid) {
      if (template.Colors.Fallback) {
        color = template.Colors.Fallback;
      }
      template.Colors.Values.forEach(value => {
        if (value.Color && checkCondition(element, value)) {
          color = value.Color;
          return;
        }
      })
    } else {
      return null;
    }
  }

  if (template.Tags && template.Tags.Operation && template.Tags.Conditions && template.Tags.Conditions.length > 0) {
    const isValid = checkConditions(element, template.Tags.Operation, template.Tags.Conditions);
    if (isValid) {
      tag = template.Tags;
    }
  }
  
  return { ...element, troisColor: color, troisTag: tag };
}

export { wildcardToRegex, applyNavigationFilter, getElementWithViewTemplateColorAndTag };